import { EditEntitySelectField } from './EditEntitySelectField';

interface EditHrEmployeeSelectFieldProps {
  fieldClassName?: string;
  label: string;
  labelClassName?: string;
  onChange: (id: string, name: string) => void;
  placeholder?: string;
  value: { id: string; name: string } | null;
}

export function EditHrEmployeeSelectField({
  fieldClassName,
  label,
  labelClassName,
  onChange,
  placeholder,
  value
}: EditHrEmployeeSelectFieldProps) {
  return (
    <EditEntitySelectField
      entityType="hrEmployee"
      fieldClassName={fieldClassName}
      label={label}
      labelClassName={labelClassName}
      onChange={onChange}
      placeholder={placeholder}
      value={value}
    />
  );
}
